import { useMemo, useState } from "react";
import { useLatest } from "../../hooks";
import * as api from "../../services/api";

export function useServiceData(service_id) {
  const [options, setOptions] = useState();
  const res = useMemo(
    () => ({ service: options ?? null, loading: options == null }),
    [options],
  );

  useLatest(
    async (signal) => {
      setOptions(null);
      const result = await api.loadServicesWithTemplates(
        {
          filter: {
            id: { eq: service_id },
          },
        },
        { signal },
      );
      setOptions(result.data.services.data[0]);
    },
    [service_id],
  );

  return res;
}
